import tweemoji from "./tweemoji";
import AspectRatio from "v-aspect-ratio";

import 'leaflet/dist/leaflet.css'
import './assets/css/bootstrap-4-grid.css';
import './prototype/helpers'

import VModal from 'vue-js-modal'

import {StfSelect, StfSelectOption} from "stf-vue-select";
import "stf-vue-select/dist/lib/stf-vue-select.min.css";
import CKEditor from '@ckeditor/ckeditor5-vue';

import {Plugin as VueFragment} from 'vue-fragment'

export default {
    install(Vue, option) {
        Vue.use(CKEditor);

        Vue.use(tweemoji);
        Vue.use(AspectRatio);
        Vue.use(VueFragment);

        Vue.use(VModal);

        Vue.component('stf-select-option', StfSelectOption);
        Vue.component('stf-select', StfSelect);


    }
};